var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['title']},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._t("subtitle",function(){return [_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]}),(_vm.$slots.tip)?_c('span',{staticClass:"title-tip"},[_vm._t("tip")],2):_vm._e(),_c('div',{staticClass:"extra"},[_vm._t("extra")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }